// import { APIHelper } from '@archistarai/auth-frontend';
// import ability from '@/auth/service,js';
// import { rules } from '@/auth/abilities';

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY');
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val);
  }

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // async fetchUserInfo({ commit, state }, force = false) {
  //   if (!force && state.AppActiveUser.guid) {
  //     return state.AppActiveUser;
  //   }
  //
  //   if (state.getUserPromise) {
  //     return state.getUserPromise;
  //   }
  //   const promise = new Promise(async (resolve, reject) => {
  //     if (!APIHelper.getCurrentefreshToken()) {
  //       APIHelper.handleLogin({ fullPath: window.location.href, query: {} });
  //       return;
  //     }
  //     try {
  //       const response = await APIHelper.AdminAPI.post('/user/getappuserinfo');
  //       if (!response) {
  //         throw new Error('Error retrieving user details');
  //         reject();
  //         commit('UPDATE_USER_PROMISE', null);
  //         return;
  //       }
  //       ability.update(rules(response.data.features));
  //       if (response.data.userRoles.includes('SuperAdmin')) {
  //         ability.update([
  //           ...ability.rules,
  //           rules([
  //             {
  //               rule: 'read',
  //               resource: 'system notes'
  //             },
  //             {
  //               rule: 'write',
  //               resource: 'system notes'
  //             },
  //             {
  //               rule: 'reset',
  //               resource: 'user passwords'
  //             },
  //             {
  //               rule: 'reset',
  //               resource: 'own passowrd'
  //             },
  //             {
  //               rule: 'read',
  //               resource: 'own invoice'
  //             },
  //             {
  //               rule: 'read',
  //               resource: 'own subscription'
  //             },
  //             {
  //               rule: 'read',
  //               resource: 'own billing'
  //             }
  //           ])
  //         ]);
  //       }
  //       commit('UPDATE_USER_INFO', response.data.userData);
  //       commit('UPDATE_USER_ROLE', response.data.userRoles);
  //       commit('UPDATE_USER_NAV_MENU', response.data.userNavMenu);
  //       commit('UPDATE_USER_RULES', response.data.features);
  //
  //       resolve(response);
  //       commit('UPDATE_USER_PROMISE', null);
  //       return;
  //     } catch (e) {
  //       reject(e);
  //       commit('UPDATE_USER_PROMISE', null);
  //       return;
  //     }
  //   });
  //   commit('UPDATE_USER_PROMISE', promise);
  //   return promise;
  // }
};

export default actions;
